/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Growth_Bullet_2Inputs */

const en_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Youth programs with Polk County Sheriff's deputies, refugees, and community partners at no cost to participants`)
};

const es_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programas juveniles con oficiales del sheriff del condado de Polk, refugiados y socios comunitarios, sin costo para los participantes`)
};

const de_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jugendprogramme mit Stellvertretern des Sheriffs von Polk County, Flüchtlingen und Gemeindepartnern, kostenlos für die Teilnehmer`)
};

const zh_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`与 Polk County 警长办公室警员、难民及社区伙伴合作开展青少年项目，参与者免费`)
};

const ar_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برامج شبابية مع نواب شريف مقاطعة Polk واللاجئين وشركاء المجتمع دون تكلفة على المشاركين`)
};

const fr_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programmes pour les jeunes avec les adjoints du shérif du comté de Polk, les réfugiés et les partenaires communautaires, sans frais pour les participants`)
};

const vi_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chương trình thanh thiếu niên với phó cảnh sát trưởng hạt Polk, người tị nạn và đối tác cộng đồng, miễn phí cho người tham gia`)
};

const sw_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programu za vijana na manaibu wa Sheriff wa Kaunti ya Polk, wakimbizi, na washirika wa jumuiya bila gharama kwa washiriki`)
};

const th_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โครงการเยาวชนร่วมกับเจ้าหน้าที่ นายอำเภอ ผู้ลี้ภัย และพันธมิตรในชุมชนของ Polk County โดยไม่มีค่าใช้จ่ายสำหรับผู้เข้าร่วม`)
};

const bs_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omladinski programi sa zamjenicima šerifa okruga Polk, izbjeglicama i partnerima zajednice, bez troška za učesnike`)
};

const ja_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポーク郡保安官事務所の警官、難民、地域パートナーとの青少年プログラム（参加者負担なし）`)
};

const ko_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포크 카운티 보안관실 대원, 난민, 지역 파트너와 함께하는 청소년 프로그램(참가자 비용 없음)`)
};

const pt_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programas para jovens com policiais do xerife do Condado de Polk, refugiados e parceiros comunitários, sem custo para os participantes`)
};

const it_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programmi giovanili con gli agenti dell'ufficio dello sceriffo della Polk County, rifugiati e partner della comunità, senza costi per i partecipanti`)
};

const sv_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungdomsprogram med poliser från Polk County Sheriff's Office, flyktingar och samhällspartner utan kostnad för deltagarna`)
};

const nl_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeugdprogramma's met hulpsheriffs, vluchtelingen en gemeenschapspartners van Polk County zonder kosten voor deelnemers`)
};

const da_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungdomsprogrammer med betjente fra Polk County Sheriff's Office, flygtninge og lokale partnere uden omkostninger for deltagerne`)
};

const nb_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungdomsprogrammer med betjenter fra Polk County Sheriff's Office, flyktninger og lokale partnere uten kostnad for deltakerne`)
};

const fi_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuoriso-ohjelmat Polk Countyn seriffin sijaisten, pakolaisten ja yhteisökumppanien kanssa maksutta osallistujille`)
};

const pl_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programy młodzieżowe z zastępcami szeryfa hrabstwa Polk, uchodźcami i partnerami społecznymi bez żadnych kosztów dla uczestników`)
};

const ru_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Молодёжные программы с сотрудниками офиса шерифа Polk County, беженцами и общественными партнёрами — бесплатно для участников`)
};

const tr_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polk County Şerif Ofisi memurları, mülteciler ve topluluk ortaklarıyla, katılımcılar için ücretsiz gençlik programları`)
};

const hi_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polk County शेरिफ़ कार्यालय के अधिकारियों, शरणार्थियों और सामुदायिक साझेदारों के साथ युवा कार्यक्रम, प्रतिभागियों के लिए निःशुल्क`)
};

const id_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program anak muda bersama deputi sheriff Polk County, pengungsi, dan mitra komunitas tanpa biaya bagi peserta`)
};

const ms_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program belia bersama timbalan syerif Polk County, pelarian dan rakan komuniti tanpa sebarang kos kepada peserta`)
};

const cs_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mládežnické programy s policisty okresu Polk, uprchlíky a komunitními partnery zdarma pro účastníky`)
};

const el_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Προγράμματα νεολαίας με τους βοηθούς του σερίφη της Κομητείας Πολκ, τους πρόσφυγες και τους εταίρους της κοινότητας χωρίς κόστος για τους συμμετέχοντες`)
};

const he_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תוכניות נוער עם שוטרי משרד השריף של Polk County, פליטים ושותפים קהילתיים, ללא עלות למשתתפים`)
};

const af_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeugprogramme met Polk County-sheriffdeputate, vlugtelinge en gemeenskapvennote sonder koste vir deelnemers`)
};

const hu_about_content_growth_bullet_2 = /** @type {(inputs: About_Content_Growth_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ifjúsági programok Polk Megyei Sheriff helyetteseivel, menekültekkel és közösségi partnerekkel, a résztvevők számára költségmentesen`)
};

/**
* | output |
* | --- |
* | "Youth programs with Polk County Sheriff's deputies, refugees, and community partners at no cost to participants" |
*
* @param {About_Content_Growth_Bullet_2Inputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_growth_bullet_2 = /** @type {((inputs?: About_Content_Growth_Bullet_2Inputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Growth_Bullet_2Inputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_growth_bullet_2(inputs)
	if (locale === "de") return de_about_content_growth_bullet_2(inputs)
	if (locale === "zh") return zh_about_content_growth_bullet_2(inputs)
	if (locale === "ar") return ar_about_content_growth_bullet_2(inputs)
	if (locale === "fr") return fr_about_content_growth_bullet_2(inputs)
	if (locale === "vi") return vi_about_content_growth_bullet_2(inputs)
	if (locale === "sw") return sw_about_content_growth_bullet_2(inputs)
	if (locale === "th") return th_about_content_growth_bullet_2(inputs)
	if (locale === "bs") return bs_about_content_growth_bullet_2(inputs)
	if (locale === "ja") return ja_about_content_growth_bullet_2(inputs)
	if (locale === "ko") return ko_about_content_growth_bullet_2(inputs)
	if (locale === "pt") return pt_about_content_growth_bullet_2(inputs)
	if (locale === "it") return it_about_content_growth_bullet_2(inputs)
	if (locale === "sv") return sv_about_content_growth_bullet_2(inputs)
	if (locale === "nl") return nl_about_content_growth_bullet_2(inputs)
	if (locale === "da") return da_about_content_growth_bullet_2(inputs)
	if (locale === "nb") return nb_about_content_growth_bullet_2(inputs)
	if (locale === "fi") return fi_about_content_growth_bullet_2(inputs)
	if (locale === "pl") return pl_about_content_growth_bullet_2(inputs)
	if (locale === "ru") return ru_about_content_growth_bullet_2(inputs)
	if (locale === "tr") return tr_about_content_growth_bullet_2(inputs)
	if (locale === "hi") return hi_about_content_growth_bullet_2(inputs)
	if (locale === "id") return id_about_content_growth_bullet_2(inputs)
	if (locale === "ms") return ms_about_content_growth_bullet_2(inputs)
	if (locale === "cs") return cs_about_content_growth_bullet_2(inputs)
	if (locale === "el") return el_about_content_growth_bullet_2(inputs)
	if (locale === "he") return he_about_content_growth_bullet_2(inputs)
	if (locale === "af") return af_about_content_growth_bullet_2(inputs)
	if (locale === "hu") return hu_about_content_growth_bullet_2(inputs)
	return en_about_content_growth_bullet_2(inputs)
});